<template>
    <div class="SResponsibility" style="margin-top: 180px;">
        <!-- <div class="SResponsibility_header"></div> -->

        <div>社会责任</div>
        <div style="display: flex;flex-direction: row;font-weight: normal;">
            <div class="line"></div>
            <div class="title" style="font-size: 18px;padding: 0 15px;">Social Responsibility</div>
            <div class="line"></div>
        </div>
        <div class="content">
            {{ $t("user.socianlResponsibility") }}
        </div>
        <div style="display: flex;flex-direction: row;justify-content: space-between;">
            <img src="@/assets/furuiImg/responsibility1.png" alt="">
            <img src="@/assets/furuiImg/responsibility2.png" alt="">
        </div>
        <div class="honor-carousel" style="margin-top: 100px;margin-bottom: 100px;">
            <!-- 左侧箭头 -->
            <button class="carousel-arrow prev-arrow" @click="prevSlide">
                <i class="el-icon-arrow-left"></i>
            </button>
            <!-- 证书容器：去掉 `:style` 动态偏移，改为固定宽度 + 居中 -->
            <div class="carousel-track" style="height: 300px;">
                <!-- 左侧 -->
                <div class="carousel-slide" :class="{ 'side-slide': true }" style="left: -200px;">
                    <img :src="getSlideImage(-1)" alt="honor" class="honor-img" />
                    <p class="honor-label">{{ getSlideLabel(-1) }}</p>
                </div>
                <!-- 当前 -->
                <div class="carousel-slide active-slide" style="left: 50%;">
                    <img :src="getSlideImage(0)" alt="honor" class="honor-img" />
                    <p class="honor-label">{{ getSlideLabel(0) }}</p>
                </div>
                <!-- 右侧 -->
                <div class="carousel-slide" :class="{ 'side-slide': true }" style="left: 200px;">
                    <img :src="getSlideImage(1)" alt="honor" class="honor-img" />
                    <p class="honor-label">{{ getSlideLabel(1) }}</p>
                </div>
            </div>
            <!-- 右侧箭头 -->
            <button class="carousel-arrow next-arrow" @click="nextSlide">
                <i class="el-icon-arrow-right"></i>
            </button>

        </div>
    </div>
</template>
<script>
export default {
    name: "SResponsibility",
    data() {
        return {
            honorList: [
                {
                    image: require('@/assets/furuiImg/resposible/responsible1.png'), // 替换为实际证书图片路径
                    label: '感谢信'
                },
                {
                    image: require('@/assets/furuiImg/resposible/responsible3.png'),
                    label: '爱心企业'
                },
                {
                    image: require('@/assets/furuiImg/resposible/responsible4.png'),
                    label: '“庆川杯”篮球赛'
                },
                {
                    image: require('@/assets/furuiImg/resposible/responsible5.png'),
                    label: '荣誉证书'
                },
                {
                    image: require('@/assets/furuiImg/resposible/responsible6.png'),
                    label: '暖身护卫'
                },
                {
                    image: require('@/assets/furuiImg/resposible/responsible2.png'),
                    label: '感谢信'
                },
            ],
            currentSlide: 1, // 当前显示的证书索引
            slideWidth: 320,// 单个证书宽度（含 margin）
            totalSlides: 0
        }
    },
    mounted() {
        console.log("SResponsibility组件已加载");
    },
    methods: {
        adjustCarousel() {
            this.$nextTick(() => {
                const track = this.$el.querySelector('.carousel-track');
                const slides = track.querySelectorAll('.carousel-slide');

                if (!slides.length) return;

                const containerWidth = this.$el.querySelector('.honor-carousel').offsetWidth;
                const slideWidth = slides[0].offsetWidth;
                const gap = 100; // 每个 slide 的左右重叠量（跟 CSS 的负 margin 一致）

                // 计算当前 active 图片应居中的偏移量
                const offset = (slideWidth + -gap) * this.currentSlide;

                // 设置 transform 让当前项居中
                track.style.transform = `translateX(${containerWidth / 2 - offset - slideWidth / 2}px)`;
            });
        },
        getSlideIndex(offset) {
            const len = this.honorList.length;
            return (this.currentSlide + offset + len) % len;
        },
        getSlideImage(offset) {
            const index = this.getSlideIndex(offset);
            return this.honorList[index].image;
        },
        getSlideLabel(offset) {
            const index = this.getSlideIndex(offset);
            return this.honorList[index].label;
        },
        prevSlide() {
            this.currentSlide = (this.currentSlide - 1 + this.honorList.length) % this.honorList.length;
        },
        nextSlide() {
            const activeSlide = document.querySelector('.active-slide');
            if (activeSlide) activeSlide.classList.remove('active-slide');

            // 延迟更新索引，确保过渡动画触发（关键）
            setTimeout(() => {
                this.currentSlide = (this.currentSlide + 1) % this.honorList.length;
                // 重新添加活跃状态
                if (activeSlide) activeSlide.classList.add('active-slide');
            }, 50); // 50ms延迟让CSS过渡生效
        }

    }
}
</script>
<style lang="less" scoped>
.honor-label {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: center;
    background-color: #66B782;
    color: white;
}

// .SResponsibility_header {
//     width: 100%;
//     height: 520px;
//     background: url(../assets/furuiImg/SResponsibility.jpg);
//     background-size: cover;
//     background-position: center;
//     margin-bottom: 50px;
//     // margin-top: 80px;
// }

.SResponsibility {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    // margin-top: 100px;
    font-size: 25px;
    font-weight: bold;
    color: black;
    margin-top: 80px;
    // padding: 100px 100px;
}

.content {
    padding: 0 100px;
    margin: 50px 0;
}

.line {
    flex: 1;
    height: 2px;
    background: #000;
    width: 50px;
    align-items: center;
    display: flex;
    margin-top: 12px;
}

.content {
    font-size: 16px;
    font-weight: normal;
    text-align: left;
    margin-top: 20px;
    text-indent: 2em;
}

.honor-carousel {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    width: 100%;
    margin: 0 auto;
    overflow: visible;
    padding: 50px 200px;
}

.carousel-track {
    display: flex;
    justify-content: center;
    align-items: center;
}

.carousel-slide {
    width: 300px;
    z-index: 1;
    opacity: 0.6;
    transition: all 0.5s cubic-bezier(0.34, 1.56, 0.64, 1);
    transform: scale(0.8);
}

.carousel-slide img {
    width: 100%;
    border-radius: 4px;
}

.active-slide {
    transform: scale(1.2);
    z-index: 10;
    opacity: 1;
}

.side-slide {
    transform: scale(0.9);
}

.carousel-arrow {
    position: absolute;
    top: 50%;
    z-index: 20;
    background: rgba(0, 0, 0, 0.3);
    color: #fff;
    border: none;
    padding: 10px 15px;
    cursor: pointer;
    font-size: 20px;
    border-radius: 4px;
    transition: all 0.3s ease;
}


.honor-img {
    transition: all 0.5s ease;

    &:hover {
        box-shadow: 0 10px 20px rgba(0, 0, 0, 0.15);
    }
}

.prev-arrow {
    left: 190px;
}

.next-arrow {
    right: 190px;
}
</style>
